import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Welcome<code>To my</code> Portfolio
        </p>
        <a
          className="App-link"
          href="https://linkedin.com/in/hamzadada"
          target="_blank"
          rel="noopener noreferrer"
        >
          Enter here
        </a>
      </header>
    </div>
  );
}

export default App;
